import { render } from "./CEditPageName.vue?vue&type=template&id=5e49cd17"
import script from "./CEditPageName.vue?vue&type=script&lang=js"
export * from "./CEditPageName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__